module.exports = __webpack_public_path__ + "img/pic_330101.7e6248de.jpg";